module.exports = __webpack_public_path__ + "img/衢州市旧机动车辆交易中心有限责任公司.fab450d1.jpg";